/**
 * Resolves the effective event-scheduler payload for job create validation and API payloads.
 * Prefers Redux `eventScheduler`; falls back to the selected quote service's `eventPreferences`.
 */
export function resolveJobEventSchedulerPayload(state: {
  eventScheduler?: unknown;
  selectedService?: { service?: { eventPreferences?: unknown } };
  quote?: { services?: Array<{ eventPreferences?: unknown }> };
}): Record<string, unknown> | null {
  if (state.eventScheduler && typeof state.eventScheduler === "object") {
    return state.eventScheduler as Record<string, unknown>;
  }
  const fromService = state.selectedService?.service?.eventPreferences || state.quote?.services?.[0]?.eventPreferences;
  if (fromService && typeof fromService === "object") {
    return fromService as Record<string, unknown>;
  }
  return null;
}
